import React from 'react';
import BaseTasksPage from '../BaseTasksPage';
import { ProjectPlanTask } from '../projectPlanTaskService';
import useAdditionalWorkflowLaunchNavigator from './additionalWorkflowLaunchNavigator';
import AdditionalWorkflowSteps, { AdditionalWorkflowStepId } from './AdditionalWorkflowSteps';
import { useConflictsContext } from './AdditionalWorkflowLaunchWrapper';

export default function AdditionalWorkflowKeyDatesPage() {
  const navigator = useAdditionalWorkflowLaunchNavigator();
  const conflictsContext = useConflictsContext();

  return (
    <BaseTasksPage
      filterFunc={(task: ProjectPlanTask) => task.isKeyDate}
      roadmap={(
        <AdditionalWorkflowSteps
          currentStep={AdditionalWorkflowStepId.KEY_DATES}
          hasConflicts={conflictsContext.hasConflicts}
        />
      )}
      onNextClicked={navigator.openAllTasksPage}
      forceShowKeyDatesOnly
    />
  );
}
